import React, { Component } from "react"
import { withStyles } from '@material-ui/core/styles';
import { TextField, Select, MenuItem, InputBase, InputAdornment, IconButton, FormControl, FormHelperText } from "@material-ui/core"
import Save from "../../../../assets/img/svg/save.svg"
import { getProjectStatus } from "../../../../actions/projectAction";
import { getlookupdocinfo } from "../../../../actions/MasterDataAction";
import { addprojectbasicinfo, filedeleteprojectownerlogo, filedeleteprojectheaderlogo, filedeleteprojectlogo, addprojectlogoinfo, getprojectbasicinfo, deleteproject, filedeleteproject, putprojectbasicinfo, addprojectinchargeinfo, addprojecthistoryinfo } from "../../../../actions/AddNewProjectAction"
import Cancel from "../../../../assets/img/svg/cancel.svg"
import image from "../../../../assets/img/svg/Image.svg"
import withRouter from "../../../custom/withRouter";
import { connect } from "react-redux";
import PropTypes from 'prop-types';
import styles from "../../../../assets/jss/customStyle";
import AttachFileIcon from '@material-ui/icons/AttachFile';
import Delete from "../../../../assets/img/svg/delete.svg"
import del from "../../../../assets/img/svg/Del.svg"
import $ from "jquery"
import moment from "moment"
import List from '@material-ui/core/List';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import axios from "axios";
import API from "../../../../_helpers/endpointService"
import deactive from '../../../../assets/img/svg/deactive.svg';
import { getSettingsFormat } from "../../../../actions/SettingsAction"
import InnerImageZoom from "react-inner-image-zoom";
import ReactSelect from "react-select";
import { dropDownOptions } from "../../../common/commonFunction";

const BootstrapError = withStyles((theme) => ({
    root: {
        'label + &': {
            marginTop: theme.spacing(3),
        },
    },
    input: {
        borderRadius: 0,
        position: 'relative',
        backgroundColor: theme.palette.background.paper,
        border: '1px solid #f44336',
        fontSize: 16,
        padding: '10px 26px 10px 12px',
        transition: theme.transitions.create(['border-color', 'box-shadow']),
    },
}))(InputBase);

const BootstrapInput = withStyles((theme) => ({
    root: {
        'label + &': {
            marginTop: theme.spacing(3),
        },
    },
    input: {
        borderRadius: 0,
        position: 'relative',
        backgroundColor: theme.palette.background.paper,
        border: '1px solid #ced4da',
        fontSize: 16,
        padding: '10px 26px 10px 12px',
        transition: theme.transitions.create(['border-color', 'box-shadow']),
    },
}))(InputBase);

const customStyles = {
    control: (base, state) => ({
        ...base,
        borderColor: state.isFocused
            ? "red"
            : base.borderColor,
        '&:hover': {
            borderColor: state.isFocused
                ? "red"
                : base.borderColor,
        }
    })
};

class AddBI extends Component {
    constructor(props) {
        super(props)
        this.inputFile = React.createRef();
        this.inputFile1 = React.createRef();
        this.inputFile2 = React.createRef();
        this.state = {
            isMobile: false,
            menu: true,
            isError1: false,
            isError2: false,
            isError3: false,
            isError5: false,
            isEdit: false,
            completeDateError: false,
            Logo: [],
            cancel: false,
            OwnerLogo: [],
            HeaderLogo: [],
            LogoIndex: 0,
            LogoAwsName: "",
            OwnerLogoIndex: 0,
            OwnerLogoAwsName: "",
            HeaderLogoIndex: 0,
            HeaderLogoAwsName: "",
            checkbox: true,
            ProjectId: 0,
            ProjectName: "New Project",
            helperText: "",
            FileUrl: "",
            FileName: "",
            dateFormat: 'DD/MM/YYYY',
            addData: {
                "ProjectId": 0,
                "ProjectName": "",
                "ProjectStartDate": null,
                "ProjectCompletionDate": null,
                "ExtensionDate": null,
                "EstimatedCompletionDate": null,
                "Status": "Not Started",
                "Comments": "",
                "YardId": 0,
                "YardName": "",
                "Modifiedby": "",
                "ActionBy": ""
            },
            yardOptions: [],
            yardArray: [],
            defaultYardOptions: [],
            getLookupYard: {
                Name: "",
                PageNumber: 1,
                PageSize: 1000
            }
        }
    };

    componentDidMount() {
        const { dispatch } = this.props;
        this.props.dispatch(getSettingsFormat(this.state.addData.ProjectId))
        window.location.pathname === "/basicinformation/add" ? this.state.isEdit = false : this.state.isEdit = true;
        this.state.addData.Modifiedby = localStorage.getItem("UserRoles");
        this.state.addData.ActionBy = localStorage.getItem("UserRoles");
        dispatch(getlookupdocinfo("Status"))
        this.getlookupYard(this.state.getLookupYard);
        this.setState({})
        this.interval = setInterval(() => {
            this.resize()
        }, 10);
    }

    getlookupYard = (data) => {
        let apiUrl = API.ACTION_YARDLOOKUP + '?Name=' + data.Name + '&PageNumber=' + data.PageNumber + '&PageSize=' + data.PageSize;
        axios({
            method: "GET",
            url: apiUrl,
        })
            .then((response) => {
                if (response?.status === 200) {
                    response?.data?.YardData.sort((a, b) => {
                        return a.Id - b.Id;
                    })
                    this.setState({
                        yardOptions: dropDownOptions(response?.data?.YardData)?.props?.children
                    })
                    this.callbackGetProjectBasicInfo();
                } else {
                    this.callbackGetProjectBasicInfo();
                }
            })
            .catch((error) => {
                this.callbackGetProjectBasicInfo();
                if (error?.response?.status === 401) {
                }
            });
    };

    callbackGetProjectBasicInfo = () => {
        if (this.state.isEdit == true) {
            this.getprojectbasicinfo(localStorage.getItem("DashId"))
            this.state.dateFormat = this.props.settings?.Convention ? this.props.settings?.Convention : 'DD/MM/YYYY'
        }  else if (this.state.isEdit == false) {
            if (localStorage.getItem("addeditid") != null) {
                this.getprojectbasicinfo(localStorage.getItem("addeditid"))
                this.state.dateFormat = 'DD/MM/YYYY'
            }
        }
    }

    yardChange = (e) => {
        this.setState({
            addData: {
                ...this.state.addData,
                YardName: e?.value?.split(",")[1],
                YardId: e?.value?.split(",")[0] ? parseInt(e?.value?.split(",")[0]) : 0
            }
        })
        this.state.yardArray = e;
        this.setState({});
    }

    getprojectbasicinfo = (data) => {
        let apiUrl = API.ADDEDIT_PROJECT + data;
        // this.props.dispatch({ type: "SHOW_LOADER", data: true })
        axios({
            method: "get",
            url: apiUrl,
            data: data,
        })
            .then((response) => {
                if (response?.status === 200) {
                    this.state.ProjectId = response.data?.ProjectId;
                    this.state.addData.ProjectId = response.data?.ProjectId;
                    this.state.addData.ProjectName = response.data?.ProjectName;
                    this.state.addData.ProjectCompletionDate = response.data?.ProjectCompletionDate ? response.data?.ProjectCompletionDate : null
                    this.state.addData.ProjectStartDate = response.data?.ProjectStartDate ? response.data?.ProjectStartDate : null
                    this.state.addData.ExtensionDate = response.data?.ExtensionDate ? response.data?.ExtensionDate : null
                    this.state.addData.EstimatedCompletionDate = response.data?.EstimatedCompletionDate ? response.data?.EstimatedCompletionDate : null
                    this.state.addData.Status = response.data?.Status;
                    this.state.addData.Comments = response.data?.Comments;
                    this.state.addData.YardId = response?.data?.YardId;
                    this.state.addData.YardName = response?.data?.YardName;
                    this.state.yardArray = this.state.yardOptions?.filter((r) => parseInt(r.value?.split(",")[0]) == parseInt(response?.data?.YardId));
                    this.state.ProjectName = response.data?.ProjectName;
                    if (response?.data?.logo != null) {
                        this.state.Logo.push(response?.data?.logo)
                        this.setState({})
                    }
                    if (response?.data?.OwnerLogo != null) {
                        this.state.OwnerLogo.push(response?.data?.OwnerLogo)
                        this.setState({})
                    }
                    if (response?.data?.HeaderLogo != null) {
                        this.state.HeaderLogo.push(response?.data?.HeaderLogo)
                        this.setState({})
                    }
                    localStorage.setItem("ProjectName", response.data?.ProjectName)
                    this.setState({})
                    // this.props.dispatch({ type: "SHOW_LOADER", data: false })
                } else {
                    // this.props.dispatch({ type: "SHOW_LOADER", data: false })
                }
            })
            .catch((error) => {
                if (error?.response?.status === 401) {
                    // this.props.dispatch({ type: "SHOW_LOADER", data: false })
                }
            });

    };

    componentWillUnmount() {
        clearInterval(this.interval);
        $("#BI .MuiListItemText-primary").removeClass("fw-bolder")
        $("#BIL").removeClass("active-color")
    }

    // sidebar = () => {
    //     if (this.state.isEdit == true) {
    //         this.props.navigate("/sidebareditproject");
    //     }
    //     else {
    //         this.props.navigate("/sidebaraddproject");
    //     }
    // }
    sidebar = () => {
        if (this.state.cancel === true) {
            window.$("#cancelpopup1").modal("show");
        }
        else {
            this.props.dispatch({ type: "CANCEL", data: false });
            if (this.state.isEdit == true) {
                this.props.navigate("/sidebareditproject");
            }
            else {
                this.props.navigate("/sidebaraddproject");
            }
        }

    };
    SideBarCancel = () => {
        this.props.dispatch({ type: "CANCEL", data: false });
        window.$("#cancelpopup1").modal("hide");
        if (this.state.isEdit == true) {
            this.props.navigate("/sidebareditproject");
        }
        else {
            this.props.navigate("/sidebaraddproject");
        }
    }
    resize = () => {
        if (window.innerWidth < 850) {
            this.setState({
                isMobile: true
            })
        }
        else {
            this.setState({
                isMobile: false
            })
        }
        $("#BasicInformation1 .MuiListItemText-primary").addClass("fw-bolder")
        $("#Basic1 .MuiListItemText-primary").addClass("spanTopBar")
        $("#BasicInformation").removeClass("d-none")
        $("#BasicInformation").addClass("d-block")
        $("#BI .MuiListItemText-primary").addClass("fw-bolder")
        $("#BIL").addClass("active-color")
    };

    AttachFiles = () => {
        this.inputFile.current.click();
    };

    AttachFiles1 = () => {
        this.inputFile1.current.click();
    };

    AttachFiles2 = () => {
        this.inputFile2.current.click();
    };
    UploadFile = (e, str) => {
        this.props.dispatch({ type: "CANCEL", data: true });
        this.state.cancel = true;
        this.setState({})
        Array.from(e.target.files).forEach(async (a) => {
            let data = [{
                file: a,
                FileSize: a.size,
                check: false,
                FileName: a.name,
                FileUrl: await this.toBase64(a),
            }]
            this.state.Logo = data;
            this.setState({})
        })
    };

    OpenPopup = (i, str, name) => {
        if (str == "Logo") {
            this.state.LogoIndex = str;
            this.state.LogoAwsName = name;
            this.setState({})
            window.$("#deletepopuplogo").modal("show");
        }
        if (str == "OwnerLogo") {
            this.state.OwnerLogoIndex = str;
            this.state.OwnerLogoAwsName = name;
            this.setState({})
            window.$("#deletepopupownerlogo").modal("show");
        }
        if (str == "HeaderLogo") {
            this.state.HeaderLogoIndex = str;
            this.state.HeaderLogoAwsName = name;
            this.setState({})
            window.$("#deletepopupheaderlogo").modal("show");
        }
    }


    UploadFile1 = (e, str) => {
        this.props.dispatch({ type: "CANCEL", data: true });
        this.state.cancel = true;
        this.setState({})
        Array.from(e.target.files).forEach(async (a) => {
            let data = [{
                file: a,
                FileSize: a.size,
                check: false,
                FileName: a.name,
                FileUrl: await this.toBase64(a),
            }]
            this.state.OwnerLogo = data;
            this.setState({})
        })
    };

    UploadFile2 = (e, str) => {
        this.props.dispatch({ type: "CANCEL", data: true });
        this.state.cancel = true;
        this.setState({})
        Array.from(e.target.files).forEach(async (a) => {
            let data = [{
                file: a,
                FileSize: a.size,
                check: false,
                FileName: a.name,
                FileUrl: await this.toBase64(a),
            }]
            this.state.HeaderLogo = data;
            this.setState({})
        })
    };

    toBase64 = file => new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
    });

    setCheckbox = (id, str) => {
        if (str == "Logo") {
            this.state.Logo.map((i, ind) => {
                if (ind == id) {
                    i.check = !i.check;
                }
            })
        }
        if (str == "OwnerLogo") {
            this.state.OwnerLogo.map((i, ind) => {
                if (ind == id) {
                    i.check = !i.check;
                }
            })
        }
        if (str == "HeaderLogo") {
            this.state.HeaderLogo.map((i, ind) => {
                if (ind == id) {
                    i.check = !i.check;
                }
            })
        }
    };

    AddCancel1 = () => {
        if (this.state.cancel == true) {
            window.$("#cancelpopup").modal("show");
        }
        else {
            this.props.dispatch({ type: "CANCEL", data: false });
            this.props.navigate(`/projectlist`)
        }
    }

    AddCancel = () => {
        this.props.dispatch({ type: "CANCEL", data: false });
        window.$("#cancelpopup").modal("hide");
        this.props.navigate(`/projectlist`)
    };

    handleInputChange = (e, node) => {
        this.props.dispatch({ type: "CANCEL", data: true });
        this.state.cancel = true;
        if (node === "Comments") {
            if (e.target.value.length - 1 < 1000) {
                this.state.addData.Comments = e.target.value;
            }
        } else {
            this.state.addData[node] = e.target.value;
        }
        this.setState({});
        // }
    };

    handleDateChange = (e, node) => {
        this.props.dispatch({ type: "CANCEL", data: true });
        this.state.cancel = true;
        this.setState({})
        if (e.target.value == "") {
            this.state.addData[node] = null;
            this.setState({});
        } else {
            this.state.addData[node] = e.target.value
            this.setState({});
        }
        if (node == "ProjectCompletionDate") {
            if (this.state.addData.ProjectStartDate == null) {
                this.state.helperText = "Please fill ProjectStartDate";
            }
            if (Date.parse(this.state.addData.ProjectStartDate) < Date.parse(e.target.value)) {
                this.state.helperText = "Valid";
                this.setState({})
            }
            else {
                this.state.helperText = "Not Valid";
                this.setState({})
            }
            this.setState({})
        }
        if (node == "EstimatedCompletionDate") {
            if (this.state.addData.ProjectStartDate == null) {
                this.state.helperText = "Please fill ProjectStartDate";
            }
            if (Date.parse(this.state.addData.ProjectStartDate) < Date.parse(moment(e.target.value).format('YYYY-MM-DD'))) {
                this.state.helperText = "Valid";
                this.setState({})
            }
            else {
                this.state.helperText = "Not Valid";
                this.state.addData.EstimatedCompletionDate = "";
                this.setState({})
            }
            this.setState({})
        }
        if (node == "ProjectStartDate") {
            if (this.state.addData.ProjectCompletionDate != null) {
                if (Date.parse(this.state.addData.ProjectCompletionDate) < Date.parse(moment(e.target.value).format('YYYY-MM-DD'))) {
                    this.state.helperText = "Not Valid";
                    this.setState({})
                }
                else {
                    this.state.helperText = "Valid";
                    this.setState({})
                }
            }
        }
        if (node == "ExtensionDate") {
            if (this.state.addData.ProjectStartDate == null) {
                this.state.helperText = "Please fill ProjectStartDate";
            }
            if (Date.parse(this.state.addData.ProjectStartDate) < Date.parse(moment(e.target.value).format('YYYY-MM-DD')) && Date.parse(this.state.addData.EstimatedCompletionDate) < Date.parse(moment(e.target.value).format('YYYY-MM-DD'))) {
                this.state.helperText = "Valid";
                this.setState({})
            }
            else {
                this.state.helperText = "Not Valid";
                this.state.addData.ExtensionDate = this.state.addData.EstimatedCompletionDate;
                this.setState({})
            }
            this.setState({})
        }
    };

    Save = () => {
        const { ProjectName, ProjectStartDate, StatusId, EstimatedCompletionDate } = this.state.addData
        if (ProjectName.trim() === "") {
            this.state.isError1 = true;
            this.state.addData.ProjectName = this.state.addData.ProjectName.trim();
            this.setState({})
        }
        else {
            this.state.isError1 = false;
            this.state.addData.ProjectName = this.state.addData.ProjectName.trim();
            this.setState({})
        }
        if (ProjectStartDate === null) {
            this.state.isError2 = true;
            this.setState({})
        }
        else {
            this.state.isError2 = false;
            this.setState({})
        }
        if (EstimatedCompletionDate === null) {
            this.state.isError4 = true;
            this.setState({})
        }
        else {
            this.state.isError4 = false;
            this.state.ExtensionDate = this.state.ExtensionDate ? this.state.ExtensionDate : EstimatedCompletionDate
            this.setState({})
        }
        if (StatusId === 0) {
            this.state.isError3 = true;
            this.setState({})
        }
        else {
            this.state.isError3 = false;
            this.setState({})
        }
        if (this.state.addData.YardName === "") {
            this.state.isError5 = true;
            this.setState({})
        }
        else {
            this.state.isError5 = false;
            this.setState({})
        }
        if (this.state.addData.Status === 'Completed') {
            if (this.state.addData.ProjectCompletionDate === '' || this.state.addData.ProjectCompletionDate === null) {
                this.state.completeDateError = true;
                this.setState({})
            }
            else {
                this.state.completeDateError = false;
                this.setState({})
            }
        }

        if (this.state.addData.ProjectName !== "" && this.state.addData.YardName !== "" && this.state.addData.ProjectStartDate !== null && this.state.addData.StatusId !== 0 && this.state.addData.EstimatedCompletionDate !== null && (this.state.addData.Status != 'Completed' || (this.state.addData.Status === 'Completed' && this.state.addData.ProjectCompletionDate != null))) {
            this.props.dispatch({ type: "CANCEL", data: false });
            if (this.state.isEdit == false) {
                let formData = new FormData()
                Array.from(this.state.Logo).forEach(async (a) => {
                    formData.append("logo", a.file)
                })
                Array.from(this.state.OwnerLogo).forEach(async (a) => {
                    formData.append("ownerlogo", a.file)
                })
                Array.from(this.state.HeaderLogo).forEach(async (a) => {
                    formData.append("headerlogo", a.file)
                })
                if (localStorage.getItem("addeditid") == null) {
                    this.setState({ cancel: false })

                    this.props.dispatch(addprojectbasicinfo(this.state.addData, formData))
                }
            }
            else {
                let formData = new FormData()
                if (this.state.Logo.length == 1) {
                    Array.from(this.state.Logo).forEach(async (a) => {
                        if (a.AwsUniqueFileName == undefined) {
                            formData.append("logo", a.file)
                        }
                    })
                }
                if (this.state.OwnerLogo.length == 1) {
                    Array.from(this.state.OwnerLogo).forEach(async (a) => {
                        if (a.AwsUniqueFileName == undefined) {
                            formData.append("ownerlogo", a.file)
                        }
                    })
                }
                if (this.state.HeaderLogo.length == 1) {
                    Array.from(this.state.HeaderLogo).forEach(async (a) => {
                        if (a.AwsUniqueFileName == undefined) {
                            formData.append("headerlogo", a.file)
                        }
                    })
                }

                this.setState({ cancel: false })
                this.state.addData.ProjectName = this.state.addData.ProjectName.trim();
                if (this.state.addData.Comments != "" || this.state.addData.Comments != null) {
                    this.state.addData.Comments = this.state.addData.Comments.trim();
                }
                this.setState({})
                this.props.dispatch(putprojectbasicinfo(this.state.addData, this.state.ProjectId, formData))
            }
        }
    };

    DeleteItemlogo = () => {
        // if (this.state.isEdit == false) {
        //     this.state.Logo = [];
        //     this.setState({})
        // } else {
        //     this.props.dispatch(filedeleteproject(this.state.ProjectId, this.state.LogoAwsName))
        // }
        // window.$("#deletepopuplogo").modal("hide");
        if (this.state.LogoAwsName == undefined) {
            this.state.Logo = [];
            this.setState({})
        } else {
            this.props.dispatch(filedeleteprojectlogo(this.state.ProjectId, this.state.LogoAwsName))
            this.state.Logo = [];
            this.setState({})
        }
        window.$("#deletepopuplogo").modal("hide");
    }

    DeleteItemownerlogo = () => {
        if (this.state.OwnerLogoAwsName == undefined) {
            this.state.OwnerLogo = [];
            this.setState({})
        } else {
            this.props.dispatch(filedeleteprojectownerlogo(this.state.ProjectId, this.state.OwnerLogoAwsName))
            this.state.OwnerLogo = [];
            this.setState({})
        }
        window.$("#deletepopupownerlogo").modal("hide");
    }

    DeleteItemheaderlogo = () => {
        if (this.state.HeaderLogoAwsName == undefined) {
            this.state.HeaderLogo = [];
            this.setState({})
        } else {
            this.props.dispatch(filedeleteprojectheaderlogo(this.state.ProjectId, this.state.HeaderLogoAwsName))
            this.state.HeaderLogo = [];
            this.setState({})
        }
        window.$("#deletepopupheaderlogo").modal("hide");
    }

    OpenPopupview = (url, name) => {
        this.state.FileUrl = url;
        this.state.FileName = name;
        this.setState({})
        window.$("#viewscreen").modal("show");
    }

    render() {
        const { isError1, isError2, isError3, isError4, isEdit, addData } = this.state;
        let { classes, projectStatus, menuToggle } = this.props;

        return (
            <>
                {
                    this.state.isMobile ?
                        <>
                            <div className="row w-100 mt-4">
                                <div className="col-7 mt-auto">
                                    <List className="pt-4 mt-4 " style={{ backgroundColor: "#F6F6F6" }}>
                                        <ListItem onClick={this.sidebar} >
                                            <ListItemText id={"Basic" + "1"} className='textNaviIcon' primary={this.state.isEdit ? "Edit Project" : "New Project"} />
                                            <NavigateNextIcon id="Basic" className="naviIcon ml-1" style={{ width: 23, height: 23 }} />
                                            <Divider className='border-bottom' />
                                        </ListItem>
                                    </List>
                                </div>
                                <div className="col-5 pt-2 mt-5 ">
                                    <h4 className="pt-2">Basic Information</h4>
                                </div>
                            </div>
                        </>
                        :
                        <></>
                }
                <div className="ml-auto scroll-hide" style={{ backgroundColor: "#FFFFFF", width: this.state.isMobile ? "100%" : menuToggle ? "calc(100% - 240px)" : "calc(100% - 64px)", marginTop: this.state.isMobile ? '' : -95 }}>
                    {
                        this.state.isMobile ?
                            <table className="dataTable border-top" width="100%">
                                <tbody>
                                    <tr>
                                        <td className="border-right text-center"><i class="fa fa-arrow-left cursorPointer" onClick={this.AddCancel1}></i></td>
                                        <td className="border-right text-center" >
                                            <button className={`${classes.button}`} onClick={() => this.Save()}><img src={Save} style={{ marginTop: '-4px' }}></img>&nbsp;Save</button>
                                        </td>
                                        <td className=" text-center">
                                            <button className={`${classes.button} `} onClick={this.AddCancel1}><img src={Cancel} style={{ marginTop: '-4px' }}></img>&nbsp;Cancel</button>
                                        </td>
                                        {/* {isEdit ?
                                            <td className="border-left">
                                                <button className={`${classes.button}`} data-target="#deletepopup" data-toggle="modal"><img src={Delete} style={{marginTop:'-4px'}}></img>&nbsp;Delete Project</button>
                                            </td> : <></>} */}
                                    </tr>
                                </tbody>
                            </table>
                            :
                            <>
                                <table className="dataTable" width="100%">
                                    <tbody>
                                        <tr>
                                            <td width="5%" className="border-right text-center">
                                                <i class="fa fa-arrow-left cursorPointer" onClick={this.AddCancel1}></i></td>
                                            <td className="95%" width="" style={{ display: 'flex' }}>
                                                <button className={classes.button} onClick={() => this.Save()}><img src={Save} style={{ marginTop: '-4px' }}></img>&nbsp;Save</button>
                                                <button className={`${classes.button} pl-3`} onClick={this.AddCancel1}><img src={Cancel} style={{ marginTop: '-4px' }}></img>&nbsp;Cancel</button>
                                            </td>
                                            {/* {isEdit ?
                                                <td className="border-left" width="80%">
                                                    <button className={`${classes.button}`} data-target="#deletepopup" data-toggle="modal"><img src={Delete} style={{ marginTop: '-4px' }}></img>&nbsp;Delete Project</button>
                                                </td> : <></>} */}
                                        </tr>
                                    </tbody>
                                </table>
                            </>
                    }
                    <div style={{ margin: this.state.isMobile ? "auto" : "5px" }}>
                        {this.state.isMobile ? "" : <h6 className="col-12 mx-2 mt-3 ml-1">{this.state.ProjectName}</h6>}
                        <div className={this.state.isMobile ? "row mx-0 mt-2" : "row mx-1 px-3 mt-2"}>
                            <div className={`row mt-2 mx-1 align-items-center ${this.state.isMobile ? "" : "text-row"}`}>
                                <div className={`col-12 col-sm-12  col-lg-2 col-xl-1 ${this.state.isMobile ? "border-left border-right border-top col-md-12" : "col-md-2  px-0 "}`}>
                                    <label className={this.state.isMobile ? "d-flex pt-2 m-0" : "float-end d-flex text-right m-0"}>Name&nbsp;:
                                        <div className={`${classes.helperText}`}>
                                            <div className="MuiFormHelperText-contained">*</div>
                                        </div>
                                    </label>
                                </div>
                                <div className={`col-12 col-sm-12  col-lg-4 col-xl-3  ${this.state.isMobile ? "border-left border-right border-bottom col-md-12 pt-1 pb-3" : "col-md-4 pt-4 pb-4"}`}>
                                    {isError1 ?
                                        <TextField
                                            variant="outlined"
                                            size="small"
                                            fullWidth
                                            error
                                            value={addData?.ProjectName}
                                            onChange={(e) => { this.handleInputChange(e, "ProjectName") }}
                                            InputProps={{
                                                className: `border-radius ${classes.inputfieldAlign}`
                                            }}
                                            classes={{ root: classes.helperText }}
                                        /> : <TextField
                                            variant="outlined"
                                            size="small"
                                            fullWidth
                                            value={addData?.ProjectName}
                                            onChange={(e) => { this.handleInputChange(e, "ProjectName") }}
                                            InputProps={{
                                                className: `border-radius ${classes.inputfieldAlign}`
                                            }}
                                        />
                                    }
                                </div>
                                <div className={`col-12 col-sm-12  col-lg-2 col-xl-1 ${this.state.isMobile ? "border-left border-right  col-md-12" : "col-md-2  px-0"}`}>
                                    <label className={this.state.isMobile ? "d-flex pt-2 m-0" : "float-end d-flex text-right m-0"}>Start Date&nbsp;:
                                        <div className={`${classes.helperText}`}>
                                            <div className="MuiFormHelperText-contained">*</div>
                                        </div>
                                    </label>
                                </div>
                                <div className={`col-12 col-sm-12 col-lg-4 col-xl-3  ${this.state.isMobile ? "border-left border-right border-bottom col-md-12 pt-1 pb-3" : "col-md-4 pt-4 pb-4"}`}>
                                    {isError2 ?
                                        <TextField
                                            variant="outlined"
                                            size="small"
                                            fullWidth
                                            error
                                            id="type-date"
                                            value={this.state.addData.ProjectStartDate && moment(this.state.addData.ProjectStartDate).format("yyyy-MM-DD")}

                                            placeholder={this.state.addData.ProjectStartDate && moment(this.state.addData.ProjectStartDate).format(this.state.dateFormat)}
                                            type="date"
                                            onChange={(e) => { this.handleDateChange(e, "ProjectStartDate") }}
                                            InputProps={{
                                                className: `border-radius ${classes.inputfieldAlign}`
                                            }}
                                            classes={{ root: classes.helperText }}
                                        /> : <TextField
                                            variant="outlined"
                                            size="small"
                                            fullWidth
                                            id="type-date"
                                            value={this.state.addData.ProjectStartDate && moment(this.state.addData.ProjectStartDate).format("yyyy-MM-DD")}

                                            placeholder={this.state.addData.ProjectStartDate && moment(this.state.addData.ProjectStartDate).format(this.state.dateFormat)}
                                            onChange={(e) => { this.handleDateChange(e, "ProjectStartDate") }}
                                            type="date"
                                            InputProps={{
                                                className: `border-radius ${classes.inputfieldAlign}`
                                            }}
                                        />
                                    }
                                </div>
                                <div className={`col-12 col-sm-12  col-lg-2 col-xl-1 ${this.state.isMobile ? "border-left border-right  col-md-12" : "col-md-2  px-0 "}`}>
                                    <label className={this.state.isMobile ? "d-flex pt-2 m-0" : "d-flex float-end text-right m-0"}>Estimated Completion Date&nbsp;:
                                        <div className={`${classes.helperText}`}>
                                            <div className="MuiFormHelperText-contained">*</div>
                                        </div>
                                    </label>
                                </div>
                                <div className={`col-12 col-sm-12 col-lg-4 col-xl-3  ${this.state.isMobile ? "border-left border-right border-bottom col-md-12 pt-1 pb-3" : "col-md-4 pt-4 pb-4"}`}>
                                    {isError4 ?
                                        <TextField
                                            variant="outlined"
                                            size="small"
                                            fullWidth
                                            error
                                            id="type-date"
                                            type="date"
                                            value={this.state.addData.EstimatedCompletionDate && moment(this.state.addData.EstimatedCompletionDate).format("yyyy-MM-DD")}
                                            placeholder={this.state.addData.EstimatedCompletionDate && moment(this.state.addData.EstimatedCompletionDate).format(this.state.dateFormat)}
                                            onChange={(e) => { this.handleDateChange(e, "EstimatedCompletionDate") }}
                                            InputProps={{
                                                className: `border-radius ${classes.inputfieldAlign}`
                                            }}
                                            classes={{ root: classes.helperText }}
                                        /> : <TextField
                                            type="date"
                                            variant="outlined"
                                            size="small"
                                            id="type-date"
                                            fullWidth
                                            value={this.state.addData.EstimatedCompletionDate && moment(this.state.addData.EstimatedCompletionDate).format("yyyy-MM-DD")}
                                            placeholder={this.state.addData.EstimatedCompletionDate && moment(this.state.addData.EstimatedCompletionDate).format(this.state.dateFormat)}
                                            onChange={(e) => { this.handleDateChange(e, "EstimatedCompletionDate") }}
                                            InputProps={{
                                                className: `border-radius ${classes.inputfieldAlign}`
                                            }}
                                        />
                                    }
                                </div>
                            </div>
                            <div className={`row mx-1 align-items-center ${this.state.isMobile ? "" : "border-left border-right border-bottom"}`}>
                                <div className={`col-12 col-sm-12  col-lg-2 col-xl-1 ${this.state.isMobile ? "border-left border-right  col-md-12" : "col-md-2 text-right"}`}>
                                    <label className={this.state.isMobile ? "d-flex pt-2 m-0" : "m-0 text-right float-end"}>Extension Date&nbsp;:
                                    </label>
                                </div>
                                <div className={`col-12 col-sm-12  col-lg-4 col-xl-3  ${this.state.isMobile ? "border-left border-right border-bottom col-md-12 pt-2 pb-3" : "col-md-4 pt-4 pb-4"}`}>
                                    <TextField
                                        variant="outlined"
                                        size="small"
                                        fullWidth
                                        id="type-date"
                                        value={this.state.addData.ExtensionDate && moment(this.state.addData.ExtensionDate).format("yyyy-MM-DD") != "0001-00-01" && moment(this.state.addData.ExtensionDate).format("yyyy-MM-DD") != "0001-01-01" && moment(this.state.addData.ExtensionDate).format("yyyy") != "0001" && moment(this.state.addData.ExtensionDate).format("yyyy-MM-DD")}
                                        placeholder={this.state.addData.ExtensionDate && moment(this.state.addData.ExtensionDate).format("yyyy-MM-DD") != "0001-00-01" && moment(this.state.addData.ExtensionDate).format("yyyy-MM-DD") != "0001-01-01" && moment(this.state.addData.ExtensionDate).format("yyyy") != "0001" ? moment(this.state.addData.ExtensionDate).format(this.state.dateFormat) : ""}
                                        onChange={(e) => { this.handleDateChange(e, "ExtensionDate") }}
                                        type="date"
                                        InputProps={{
                                            className: `border-radius ${classes.inputfieldAlign}`
                                        }}
                                    />
                                </div>
                                <div className={`col-12 col-sm-12  col-lg-2 col-xl-1 ${this.state.isMobile ? "border-left border-right  col-md-12" : "col-md-2 text-right"}`}>
                                    <label className={this.state.isMobile ? "d-flex pt-2 m-0" : "form-group m-0 text-right float-end "}>Status&nbsp;:</label>
                                </div>
                                <div className={`col-12 col-sm-12 col-lg-4 col-xl-3  ${this.state.isMobile ? "border-left border-right border-bottom col-md-12 pt-2 pb-3" : "col-md-4 pt-4 pb-4"}`}>
                                    <>
                                        {isError3 ?
                                            <FormControl error fullWidth>
                                                <select
                                                    id="demo-customized-select"
                                                    fullWidth
                                                    value={this.state.addData?.Status}
                                                    style={{ height: "40px", borderColor: "red", paddingLeft: "10px" }}
                                                    variant="outlined"
                                                    onChange={(e) => { this.handleInputChange(e, "Status") }}
                                                >
                                                    <option value={0}>Select Status</option>
                                                    {projectStatus &&
                                                        projectStatus.map((i) => {
                                                            return i.Name != "" ? <option value={i.Name}>{i.Name}</option> : <></>
                                                        })}
                                                </select>
                                                <FormHelperText>Required field must be filled in</FormHelperText>
                                            </FormControl> :
                                            <select
                                                fullWidth
                                                value={this.state.addData?.Status}
                                                style={{ height: "40px" }}
                                                className="form-control border-radius"
                                                onChange={(e) => { this.handleInputChange(e, "Status") }}
                                            >
                                                <option value={0}>Select Status</option>
                                                {projectStatus &&
                                                    projectStatus.map((i) => {
                                                        return i.Name != "" ? <option value={i.Name}>{i.Name}</option> : <></>;
                                                    })}
                                            </select>}
                                    </>
                                </div>
                                {(this.state.addData?.Status == "Completed" || this.state.addData.Status == "completed") ? <>
                                    <div className={`col-12 col-sm-12  col-lg-2 col-xl-1 ${this.state.isMobile ? "border-left border-right  col-md-12" : "col-md-2 px-0"}`}>
                                        <label className={this.state.isMobile ? "d-flex pt-2 m-0" : "d-flex float-end text-right m-0"}>Completion Date&nbsp;:
                                            <div className={`${classes.helperText}`}>
                                                <div className="MuiFormHelperText-contained">*</div>
                                            </div>
                                        </label>
                                    </div>
                                    <div className={`col-12 col-sm-12 col-lg-4 col-xl-3  ${this.state.isMobile ? "border-left border-right border-bottom col-md-12 pt-2 pb-3" : "col-md-4 pb-4 pt-4"}`}>
                                        {this.state.completeDateError ?
                                            < TextField
                                                variant="outlined"
                                                size="small"
                                                fullWidth
                                                id="type-date"
                                                error
                                                value={addData.ProjectCompletionDate && moment(addData.ProjectCompletionDate).format("yyyy-MM-DD")}
                                                placeholder={addData.ProjectCompletionDate && moment(addData.ProjectCompletionDate).format(this.state.dateFormat)}
                                                onChange={(e) => { this.handleDateChange(e, "ProjectCompletionDate") }}
                                                type="date"
                                                InputProps={{
                                                    className: `border-radius ${classes.inputfieldAlign}`
                                                }}
                                            /> :
                                            <TextField
                                                variant="outlined"
                                                size="small"
                                                fullWidth
                                                id="type-date"
                                                value={addData.ProjectCompletionDate && moment(addData.ProjectCompletionDate).format("yyyy-MM-DD")}
                                                placeholder={addData.ProjectCompletionDate && moment(addData.ProjectCompletionDate).format(this.state.dateFormat)}
                                                onChange={(e) => { this.handleDateChange(e, "ProjectCompletionDate") }}
                                                type="date"
                                                InputProps={{
                                                    className: `border-radius ${classes.inputfieldAlign}`
                                                }}
                                            />}

                                    </div>
                                </> : <></>}
                            </div>

                            <div className={`row mx-1 align-items-center ${this.state.isMobile ? "" : "border-left border-right border-bottom"}`}>
                                <div className={`col-12 col-sm-12  col-lg-2 col-xl-1  ${this.state.isMobile ? "border-left border-right" : "mt-2 col-md-2 px-0"}`}>
                                    <label className={this.state.isMobile ? "d-flex pt-2" : " float-end d-flex text-right"}>Recycling Yard Name&nbsp;:
                                        <div className={`${classes.helperText}`}>
                                            <div className="MuiFormHelperText-contained">*</div>
                                        </div></label>
                                </div>
                                <div className={`col-12 col-sm-12 col-lg-4 col-xl-3  ${this.state.isMobile ? "border-left border-right col-md-12 pt-2 pb-3" : "col-md-4 pt-4 pb-4 "}`}>
                                    <ReactSelect
                                        styles={customStyles}
                                        options={this.state.yardOptions ?? []}
                                        value={this.state.yardArray}
                                        menuPortalTarget={document.body}
                                        menuShouldScrollIntoView={false}
                                        classNamePrefix={this.state.isError5 == true ? "yardNameError" : "yardName"}
                                        isSearchable={true}
                                        placeholder=""
                                        onChange={(e) => this.yardChange(e)}
                                    />
                                </div>
                            </div>

                            <div className={`row mx-1 align-items-center ${this.state.isMobile ? "" : "border-left border-right border-bottom"}`}>
                                <div className={`col-12 col-sm-12  col-lg-2 col-xl-1 ${this.state.isMobile ? "border-left border-right  col-md-12" : "col-md-2 text-right"}`}>
                                    <label className={this.state.isMobile ? "d-flex pt-2 m-0 " : "form-group m-0 text-right float-end"}>Ship Photo&nbsp;:</label>
                                </div>
                                <div className={`col-12 col-sm-12 col-lg-4 col-xl-3  ${this.state.isMobile ? "border-left border-right  col-md-12 pt-2 pb-3" : "col-md-4 pt-4 pb-4 "}`}>
                                    <TextField
                                        variant="outlined"
                                        size="small"
                                        fullWidth
                                        disabled
                                        onChange={(e) => this.UploadFile(e)}
                                        accept=".png,.jpg"
                                        placeholder="Browse File"
                                        InputProps={{
                                            endAdornment: (
                                                <InputAdornment className="mr-0">
                                                    <IconButton className="rotate p-0" onClick={this.AttachFiles}>
                                                        <AttachFileIcon />
                                                    </IconButton>
                                                </InputAdornment>
                                            ),
                                            className: `border-radius ${classes.inputfieldAlign}`
                                        }} />
                                    <input
                                        type="file"
                                        hidden
                                        accept=".png,.jpg"
                                        onChange={(e) => this.UploadFile(e)}
                                        ref={this.inputFile}
                                    />
                                </div>
                                {/* <div className={`col-12 col-sm-12  col-md-6 col-lg-6 col-xl-8 align-items-center ${this.state.isMobile ? "border-left border-right border-bottom col-md-12" : "mt-2"}`}>
                                    <div className="row px-1">
                                        {this.state.Logo && this.state.Logo.map((i, ind) => {
                                            return (<>
                                                <div className="row align-items-center">
                                                    <div className="col-12 col-sm-12 col-lg-12 col-xl-12 col-md-12 align-items-center" style={{ display: 'flex' }}>
                                                        <div className="ml-2">
                                                            <img src={i.FileUrl} className="cursorPointer" onClick={() => this.OpenPopupview(i.FileUrl, i.FileName)} style={{ width: '40px', height: '36px', marginTop: '-9px' }} />
                                                        </div>
                                                        <div>
                                                            <div onClick={() => this.OpenPopupview(i.FileUrl, i.FileName)} className="cursorPointer px-3 overflow">{i.FileName}<br></br><label style={{ color: "#B0AAAA" }}>{(i.FileSize / 1048576).toFixed(2)}&nbsp;MB</label></div>
                                                        </div>
                                                        <div className="" style={{ marginTop: '-10px' }}>
                                                            <img src={Delete} className="cursorPointer" onClick={() => { this.OpenPopup(ind, "Logo", i.AwsUniqueFileName) }} />
                                                        </div>
                                                    </div>
                                                </div>
                                            </>)
                                        })}
                                    </div>
                                </div> */}
                                <div className={`col-12 col-sm-12   col-md-6 col-lg-6 col-xl-6 pt-2 align-items-center ${this.state.isMobile ? "border-left border-right border-bottom col-md-12" : ""}`}>
                                    {this.state.Logo && this.state.Logo.map((i, ind) => {
                                        return (<>
                                            <div className="row align-items-center">
                                                <div className="col-12 col-sm-12 col-lg-12 col-xl-12 col-md-12 align-items-center" style={{ display: 'flex' }}>

                                                    <div className="ml-2">
                                                        <img src={i.FileUrl} className="cursorPointer" onClick={() => this.OpenPopupview(i.FileUrl, i.FileName)} style={{ width: '40px', height: '36px', marginTop: '-9px' }} />
                                                    </div>
                                                    <div className="col-6 col-sm-6 col-xl-4 col-md-4 col-lg-4">
                                                        <div onClick={() => this.OpenPopupview(i.FileUrl, i.FileName)} className="px-2 overflow cursorPointer">{i.FileName}<br></br><label style={{ color: "#B0AAAA" }}>{(i.FileSize / 1048576).toFixed(2)}&nbsp;MB</label></div>
                                                    </div>
                                                    <div className="" style={{ marginTop: '-16px' }}>
                                                        <img src={Delete} className="cursorPointer" onClick={() => { this.OpenPopup(ind, "Logo", i.AwsUniqueFileName) }} />
                                                    </div>
                                                </div>
                                            </div>
                                        </>)
                                    })}
                                </div>

                            </div>
                            <div className={`row mx-1 align-items-center ${this.state.isMobile ? "" : "border-left border-right border-bottom"}`}>
                                <div className={`col-12 col-sm-12  col-lg-2 col-xl-1 ${this.state.isMobile ? "border-left border-right  col-md-12" : "col-md-2 text-right"}`}>
                                    <label className={this.state.isMobile ? "d-flex pt-2 m-0 " : "form-group m-0 float-end text-right"}>Header Logo&nbsp;:</label>
                                </div>
                                <div className={`col-12 col-sm-12 col-lg-4 col-xl-3  ${this.state.isMobile ? "border-left border-right col-md-12 pt-2 pb-3" : "col-md-4 pt-4 pb-4 "}`}>
                                    <TextField
                                        variant="outlined"
                                        size="small"
                                        fullWidth
                                        disabled
                                        onChange={(e) => this.UploadFile2(e)}
                                        accept=".png,.jpg"
                                        placeholder="Browse File"
                                        InputProps={{
                                            endAdornment: (
                                                <InputAdornment className="mr-0">
                                                    <IconButton className="rotate p-0" onClick={this.AttachFiles2}>
                                                        <AttachFileIcon />
                                                    </IconButton>
                                                </InputAdornment>
                                            ),
                                            className: `border-radius ${classes.inputfieldAlign}`
                                        }} />
                                    <input
                                        type="file"
                                        hidden
                                        accept=".png,.jpg"
                                        onChange={(e) => this.UploadFile2(e)}
                                        ref={this.inputFile2}
                                    />
                                </div>
                                {/* <div className={`col-12 col-sm-12  col-md-6 col-lg-6 col-xl-8 align-items-center ${this.state.isMobile ? "border-left border-right border-bottom col-md-12" : "mt-2"}`}>
                                    <div className="row px-1">
                                        {this.state.OwnerLogo && this.state.OwnerLogo.map((i, ind) => {
                                            return (<>
                                                <div className="row align-items-center">
                                                    <div className="col-12 col-sm-12 col-lg-12 col-xl-12 col-md-12 align-items-center" style={{ display: 'flex' }}>
                                                        <div className="ml-2">
                                                            <img className="cursorPointer" src={i.FileUrl} onClick={() => this.OpenPopupview(i.FileUrl, i.FileName)} style={{ width: '40px', height: '36px', marginTop: '-9px' }} />
                                                        </div>
                                                        <div>
                                                            <label onClick={() => this.OpenPopupview(i.FileUrl, i.FileName)} className="px-3 cursorPointer pt-2 overflow">{i.FileName}<br></br><label className="cursorPointer" style={{ color: "#B0AAAA" }}>{(i.FileSize / 1048576).toFixed(2)}&nbsp;MB</label></label>
                                                        </div>
                                                        <div className="" style={{ marginTop: '-10px' }}>
                                                            <img src={Delete} className="cursorPointer" onClick={() => { this.OpenPopup(ind, "OwnerLogo", i.AwsUniqueFileName) }} />
                                                        </div>
                                                    </div>
                                                </div>
                                            </>)
                                        })}
                                    </div>
                                </div> */}
                                <div className={`col-12 col-sm-12   col-md-6 col-lg-6 col-xl-6 pt-2 align-items-center ${this.state.isMobile ? "border-left border-right border-bottom col-md-12" : ""}`}>
                                    {this.state.HeaderLogo && this.state.HeaderLogo.map((i, ind) => {
                                        return (<>
                                            <div className="row align-items-center">
                                                <div className="col-12 col-sm-12 col-lg-12 col-xl-12 col-md-12 align-items-center" style={{ display: 'flex' }}>

                                                    <div className="ml-2">
                                                        <img src={i.FileUrl} className="cursorPointer" onClick={() => this.OpenPopupview(i.FileUrl, i.FileName)} style={{ width: '40px', height: '36px', marginTop: '-9px' }} />
                                                    </div>
                                                    <div className="col-6 col-sm-6 col-xl-4 col-md-4 col-lg-4">
                                                        <div onClick={() => this.OpenPopupview(i.FileUrl, i.FileName)} className="px-2 overflow cursorPointer">{i.FileName}<br></br><label style={{ color: "#B0AAAA" }}>{(i.FileSize / 1048576).toFixed(2)}&nbsp;MB</label></div>
                                                    </div>
                                                    <div className="" style={{ marginTop: '-16px' }}>
                                                        <img src={Delete} className="cursorPointer" onClick={() => { this.OpenPopup(ind, "HeaderLogo", i.AwsUniqueFileName) }} />
                                                    </div>
                                                </div>
                                            </div>
                                        </>)
                                    })}
                                </div>
                            </div>
                            <div className={`row mx-1 align-items-center ${this.state.isMobile ? "" : "border-left border-right border-bottom"}`}>
                                <div className={`col-12 col-sm-12  col-lg-2 col-xl-1 ${this.state.isMobile ? "border-left border-right  col-md-12" : "col-md-2 text-right"}`}>
                                    <label className={this.state.isMobile ? "d-flex pt-2 m-0 " : "form-group m-0 float-end text-right"}>Footer Logo&nbsp;:</label>
                                </div>
                                <div className={`col-12 col-sm-12 col-lg-4 col-xl-3  ${this.state.isMobile ? "border-left border-right col-md-12 pt-2 pb-3" : "col-md-4 pt-4 pb-4 "}`}>
                                    <TextField
                                        variant="outlined"
                                        size="small"
                                        fullWidth
                                        disabled
                                        onChange={(e) => this.UploadFile1(e)}
                                        accept=".png,.jpg"
                                        placeholder="Browse File"
                                        InputProps={{
                                            endAdornment: (
                                                <InputAdornment className="mr-0">
                                                    <IconButton className="rotate p-0" onClick={this.AttachFiles1}>
                                                        <AttachFileIcon />
                                                    </IconButton>
                                                </InputAdornment>
                                            ),
                                            className: `border-radius ${classes.inputfieldAlign}`
                                        }} />
                                    <input
                                        type="file"
                                        hidden
                                        accept=".png,.jpg"
                                        onChange={(e) => this.UploadFile1(e)}
                                        ref={this.inputFile1}
                                    />
                                </div>
                                <div className={`col-12 col-sm-12   col-md-6 col-lg-6 col-xl-6 pt-2 align-items-center ${this.state.isMobile ? "border-left border-right border-bottom col-md-12" : ""}`}>
                                    {this.state.OwnerLogo && this.state.OwnerLogo.map((i, ind) => {
                                        return (<>
                                            <div className="row align-items-center">
                                                <div className="col-12 col-sm-12 col-lg-12 col-xl-12 col-md-12 align-items-center" style={{ display: 'flex' }}>

                                                    <div className="ml-2">
                                                        <img src={i.FileUrl} className="cursorPointer" onClick={() => this.OpenPopupview(i.FileUrl, i.FileName)} style={{ width: '40px', height: '36px', marginTop: '-9px' }} />
                                                    </div>
                                                    <div className="col-6 col-sm-6 col-xl-4 col-md-4 col-lg-4">
                                                        <div onClick={() => this.OpenPopupview(i.FileUrl, i.FileName)} className="px-2 overflow cursorPointer">{i.FileName}<br></br><label style={{ color: "#B0AAAA" }}>{(i.FileSize / 1048576).toFixed(2)}&nbsp;MB</label></div>
                                                    </div>
                                                    <div className="" style={{ marginTop: '-16px' }}>
                                                        <img src={Delete} className="cursorPointer" onClick={() => { this.OpenPopup(ind, "OwnerLogo", i.AwsUniqueFileName) }} />
                                                    </div>
                                                </div>
                                            </div>
                                        </>)
                                    })}
                                </div>
                            </div>
                            {isEdit ? <>
                                <div className={`row mx-1 align-items-center ${this.state.isMobile ? "" : "border-left border-right border-bottom"}`}>
                                    <div className={`col-12 col-sm-12  col-lg-2 col-xl-1 ${this.state.isMobile ? "border-left border-right  col-md-12" : "col-md-2 text-right mt-n4"}`}>
                                        <label className={this.state.isMobile ? "d-flex pt-2 m-0 " : "form-group m-0 float-end text-right"}>Comments&nbsp;:</label>
                                    </div>
                                    <div className={`col-12 col-sm-12 col-xl-11 col-lg-10  ${this.state.isMobile ? "border-left border-right border-bottom col-md-12 pt-2  pb-1 " : "col-md-10 pt-4  pb-2 "}`}>
                                        <TextField
                                            multiline
                                            rows={8}
                                            variant="outlined"
                                            size="small"
                                            fullWidth
                                            value={this.state.addData?.Comments}
                                            onChange={(e) => { this.handleInputChange(e, "Comments") }}
                                            InputProps={{
                                                className: `border-radius ${classes.inputfieldAlign}`
                                            }}
                                        />
                                        <label className="float-end pt-2" style={{ opacity: '0.5' }}>{this.state.addData?.Comments?.length == undefined ? 1000 - 0 : 1000 - this.state.addData?.Comments?.length}/1000 Characters left</label>
                                    </div>
                                </div>
                            </> : <></>}
                        </div>
                    </div>
                </div>
                <div class="modal fade p-5 mt-5" id="deletepopuplogo" tabindex="-1" role="dialog" aria-labelledby="deletepopupLabel" aria-hidden="true" style={{ top: "13%", left: this.state.isMobile ? "2%" : menuToggle ? "10%" : "" }}>
                    <div class="modal-dialog" role="document">
                        <div class={this.state.isMobile ? "modal-content" : "modal-content p-3"}>
                            <div class="modal-body pb-0">
                                <h1 className="text-center">
                                    <img src={del}></img>
                                </h1>
                                <div className="text-center">
                                    <h5 class="fw-bold">Are you sure you want to delete?</h5> </div>
                            </div>
                            <div class="modal-footer border-top-0 m-auto">
                                <button type="button" data-dismiss="modal" class={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} style={{ backgroundColor: "#00838F", border: "none" }} onClick={() => this.DeleteItemlogo()}><span className="" >Delete</span></button>
                                <button type="button" onClick={() => { window.$("#deletepopuplogo").modal("hide") }} id="closemodal" class={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} data-dismiss="modal" style={{ backgroundColor: "#EBEBEB", border: "none", color: "#111010" }}><span className="" >Cancel</span></button>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal fade p-5 mt-5" id="deletepopupownerlogo" tabindex="-1" role="dialog" aria-labelledby="deletepopupLabel" aria-hidden="true" style={{ top: "13%", left: this.state.isMobile ? "2%" : menuToggle ? "10%" : "" }}>
                    <div class="modal-dialog" role="document">
                        <div class={this.state.isMobile ? "modal-content" : "modal-content p-3"}>
                            <div class="modal-body pb-0">
                                <h1 className="text-center">
                                    <img src={del}></img>
                                </h1>
                                <div className="text-center">
                                    <h5 class="fw-bold">Are you sure you want to delete?</h5> </div>
                            </div>
                            <div class="modal-footer border-top-0 m-auto">
                                <button type="button" data-dismiss="modal" class={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} style={{ backgroundColor: "#00838F", border: "none" }} onClick={() => this.DeleteItemownerlogo()}><span className="" >Delete</span></button>
                                <button type="button" onClick={() => { window.$("#deletepopupownerlogo").modal("hide") }} data-dismiss="modal" id="closemodal2" class={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} style={{ backgroundColor: "#EBEBEB", border: "none", color: "#111010" }}><span className="" >Cancel</span></button>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal fade p-5 mt-5" id="deletepopupheaderlogo" tabindex="-1" role="dialog" aria-labelledby="deletepopupLabel" aria-hidden="true" style={{ top: "13%", left: this.state.isMobile ? "2%" : menuToggle ? "10%" : "" }}>
                    <div class="modal-dialog" role="document">
                        <div class={this.state.isMobile ? "modal-content" : "modal-content p-3"}>
                            <div class="modal-body pb-0">
                                <h1 className="text-center">
                                    <img src={del}></img>
                                </h1>
                                <div className="text-center">
                                    <h5 class="fw-bold">Are you sure you want to delete?</h5> </div>
                            </div>
                            <div class="modal-footer border-top-0 m-auto">
                                <button type="button" data-dismiss="modal" class={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} style={{ backgroundColor: "#00838F", border: "none" }} onClick={() => this.DeleteItemheaderlogo()}><span className="" >Delete</span></button>
                                <button type="button" onClick={() => { window.$("#deletepopupheaderlogo").modal("hide") }} data-dismiss="modal" id="closemodal2" class={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} style={{ backgroundColor: "#EBEBEB", border: "none", color: "#111010" }}><span className="" >Cancel</span></button>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal fade p-5 mt-5" id="cancelpopup" tabindex="-1" role="dialog" aria-labelledby="cancelpopupLabel" aria-hidden="true" style={{ top: "13%", left: this.state.isMobile ? "2%" : menuToggle ? "10%" : "" }}>
                    <div class="modal-dialog" role="document">
                        <div class={this.state.isMobile ? "modal-content" : "modal-content p-3"}>
                            <div class="modal-body pb-0">
                                <h1 className="text-center">
                                    <img src={del}></img>
                                </h1>
                                <div className="text-center">
                                    <h5 class="fw-bold">The data will be lost. Do you really want to cancel?</h5> </div>
                            </div>
                            <div class="modal-footer border-top-0 m-auto">
                                <button type="button" class={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} data-dismiss="modal" style={{ backgroundColor: "#00838F", border: "none" }} onClick={this.AddCancel}><span className="" >Yes</span></button>
                                <button type="button" id="closemodal1" class={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} onClick={() => window.$("#cancelpopup").modal("hide")} style={{ backgroundColor: "#EBEBEB", border: "none", color: "#111010" }}><span className="" >No</span></button>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal fade p-5 mt-5" id="cancelpopup1" tabindex="-1" role="dialog" aria-labelledby="cancelpopupLabel" aria-hidden="true" style={{ top: "13%", left: this.state.isMobile ? "2%" : menuToggle ? "10%" : "" }}>
                    <div class="modal-dialog" role="document">
                        <div class={this.state.isMobile ? "modal-content" : "modal-content p-3"}>
                            <div class="modal-body pb-0">
                                <h1 className="text-center">
                                    <img src={del}></img>
                                </h1>
                                <div className="text-center">
                                    <h5 class="fw-bold">The data will be lost. Do you really want to cancel?</h5> </div>
                            </div>
                            <div class="modal-footer border-top-0 m-auto">
                                <button type="button" class={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} data-dismiss="modal" style={{ backgroundColor: "#00838F", border: "none" }} onClick={this.SideBarCancel}><span className="" >Yes</span></button>
                                <button type="button" id="closemodal1" class={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} onClick={() => window.$("#cancelpopup1").modal("hide")} style={{ backgroundColor: "#EBEBEB", border: "none", color: "#111010" }}><span className="" >No</span></button>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal fade " id="viewscreen" tabindex="-1" role="dialog" aria-labelledby="deletepopupLabel" aria-hidden="true" style={{ top: this.state.isMobile ? "25%" : "13%", left: this.state.isMobile ? "0%" : menuToggle ? "10%" : "", overflowY: 'scroll', height: "90vh" }}>
                    <div class="modal-dialog modal-lg " role="document">
                        <div class="modal-content ">
                            <div class="modal-body pt-0 pb-2 pr-3 pl-3 ">
                                <div className="row">
                                    <div className="col-12 ">
                                        <div className='cursorPointer float-end' id="viewscreen" onClick={() => {
                                            window.$('#viewscreen').modal('hide')

                                        }} >
                                            <button className={`${classes.button} px-0 hidefield`} >&nbsp;Close</button>
                                        </div>
                                    </div>

                                    <div className='col-12 text-center'>
                                        <InnerImageZoom
                                            moveType="drag"
                                            zoomScale={2}
                                            hideCloseButton={true}
                                            src={this.state.FileUrl}
                                            hasSpacer={true}
                                            afterZoomIn={() => { $('#viewscreen > div > div ').addClass('Transparent'); $('.hidefield').removeClass('d-block'); $('.hidefield').addClass('d-none'); }}
                                            afterZoomOut={() => { $('#viewscreen > div > div ').removeClass('Transparent'); $('.hidefield').addClass('d-block'); $('.hidefield').removeClass('d-none'); }}
                                        />
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        )
    }
}
function mapDispatchToProps(dispatch) {
    return {
        dispatch,
    };
}

function mapStateToProps(state) {
    return {
        menuToggle: state.commonReducer.menuToggle,
        projectStatus: state.MasterDataReducer.Lookup_data || [],
        getbasicinfo: state.AddNewProjectReducer.getbasicinfo || [],
        getprojectid: state.AddNewProjectReducer.getprojectid || [],
        settings: state.commonReducer.settings || [],
        alertCancel: state.commonReducer.alertCancel || [],

    };
}

AddBI.propTypes = {
    classes: PropTypes.object.isRequired,
}

export default withRouter(
    connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(AddBI))
);